import { createI18n } from 'vue-i18n'
import enMessages from './locales/en.json'

// Create a type based on your baseline English file
type MessageSchema = typeof enMessages
// Create a type for your supported locales (e.g., 'en' | 'fr')
// type SupportedLocale = 'en' | string

function getCookie(name: string): string | null {
  const cookies = document.cookie.split(';')
  for (const cookie of cookies) {
    const trimmedCookie = cookie.trim()
    if (trimmedCookie.startsWith(name + '=')) {
      return trimmedCookie.substring(name.length + 1)
    }
  }
  return null
}

// FIX: Change Record<string, string> to MessageSchema to fix TS2345
const locales = import.meta.glob<{ default: MessageSchema }>('./locales/*.json')

const initialLocale = getCookie('user_language') || 'en'
const loadedLanguages: string[] = ['en']

export const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    en: enMessages,
  },
})

export default i18n

export async function loadLanguageAsync(locale: string) {
  if (loadedLanguages.includes(locale)) {
    // FIX: Cast to 'any' or your SupportedLocale type to fix TS2322
    ;(i18n.global.locale.value as string) = locale
    return
  }

  const loadLocaleMessage = locales[`./locales/${locale}.json`]

  if (loadLocaleMessage) {
    try {
      const module = await loadLocaleMessage()
      // Now module.default matches the expected structure of enMessages
      i18n.global.setLocaleMessage(locale, module.default)
      loadedLanguages.push(locale)
      ;(i18n.global.locale.value as string) = locale
      document.querySelector('html')?.setAttribute('lang', locale)
    } catch (e) {
      console.error(`[i18n] Failed to load locale: ${locale}`, e)
      i18n.global.locale.value = 'en'
    }
  } else {
    console.warn(`[i18n] Locale ${locale} not found, falling back to English.`)
    i18n.global.locale.value = 'en'
  }
}

export async function initializeI18n() {
  if (initialLocale !== 'en') {
    await loadLanguageAsync(initialLocale)
  } else {
    document.querySelector('html')?.setAttribute('lang', 'en')
  }
}
